module.exports = __webpack_public_path__ + "7c0de43dedd745ae94eb9d524e299ab8.svg";